import type { Filter } from './useStreamFilters'

const STREAM_KEYS_TO_CLEAR: Array<keyof Filter | 'page' | 'clear' | 'meme' | 'people'> = [
    'questId',
    'questIds',
    'notifications',
    'message_notis',
    'upvalue_notis',
    'system_notis',
    'private',
    'private_all',
    'clip',
    'public_clip',
    'public',
    'following',
    'hodlocker',
    'twetch',
    'treechat',
    'participants',
    'link',
    'all',
    'user',
    'users',
    'profile_thread_scope',
    'user_ordinals',
    'public_user',
    'from_user',
    'team_ids',
    'history',
    'starred',
    'order',
    'top_window',
    'query',
    'ordinals',
    'market',
    'market_cards',
    'ordinals_scope',
    'min_sats',
    'streams',
    'streams_scope',
    'memes',
    'memes_scope',
    'user_music',
    'private_mentions',
    'private_messages',
    'private_message_requests',
    'search',
    'archived',
    'answerId',
    // legacy/external keys we still need to scrub
    'page',
    'clear',
    'meme',
    // removed People stream; saved filters may still carry it
    'people',
]

export const clearStream = (filter: Filter = {}) => {
    const newFilter: Filter & Record<string, unknown> = { ...filter }

    STREAM_KEYS_TO_CLEAR.forEach(key => {
        if (key in newFilter) {
            delete newFilter[key]
        }
    })

    return newFilter
}

export function questFilterFromPath(path: string): Pick<Filter, 'questId' | 'answerId'> | null {
    const questAnswerMatch = path.match(/^\/quest\/([^/]+)\/answer\/([^/]+)\/?$/)
    if (questAnswerMatch) {
        return {
            questId: questAnswerMatch[1],
            answerId: questAnswerMatch[2],
        }
    }

    const questMatch = path.match(/^\/quest\/([^/]+)\/?$/)
    if (questMatch) {
        return {
            questId: questMatch[1],
        }
    }

    return null
}

export function questPathFromFilter(filter: Pick<Filter, 'questId' | 'answerId'>): string | null {
    if (!filter.questId) return null

    let path = '/quest/' + filter.questId
    if (filter.answerId) path += '/answer/' + filter.answerId
    return path
}

export function buildNotificationsFilter(
    filter?: Filter | null,
    notificationFilter: Partial<Filter> = {},
): Filter {
    return {
        ...clearStream(filter || {}),
        ...notificationFilter,
        notifications: true,
    }
}
